import type { RouteObject } from "react-router-dom";

import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import ChatIaLayout from "./ChatIaLayout";
import ChatIaView from "./ChatIaView";
import { CHAT_IA_BASE } from "./config";

export const chatIaRoute: RouteObject = {
  path: CHAT_IA_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <ChatIaLayout />,
      children: [{ index: true, element: <ChatIaView /> }],
    },
  ],
};
